import React from "react";

export default function NewsSkeletonList() {
  return (
    <div className="grid gap-4 p-4 sm:p-5 xl:grid-cols-2">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-[1.7rem] border border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-950"
        >
          <div className="grid sm:grid-cols-[190px_1fr]">
            <div className="h-48 animate-pulse bg-slate-200 dark:bg-slate-800" />

            <div className="space-y-4 p-5">
              <div className="h-3 w-28 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              <div className="h-6 w-3/4 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              <div className="space-y-2">
                <div className="h-3 w-full animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
                <div className="h-3 w-5/6 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
                <div className="h-3 w-2/3 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              </div>

              <div className="flex gap-2">
                <div className="h-10 w-20 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
                <div className="h-10 w-24 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
                <div className="h-10 w-24 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}